// live相关操作
export const live = {
  getLiveDetail: 'GET_LIVE_DETAIL', // 获取活动详情
  getPhotoList: 'GET_PHOTO_LIST', // 获取活动图片列表
  setPageIndex: 'SET_PAGEINDEX', // 设置页面index
  getInteractionList: 'GET_INTERACTION_LIST', //  获得指定活动的互动列表
  getInteractionDetail: 'GET_INTERACTION_DETAIL', // 获取互动详情信息
  getInteractionListByUserId: 'GET_INTERACTION_LIST_BY_USERID', // 查询某个用户的互动列表
  getLargePhotoList: 'GET_LARGE_PHOTO_LIST', // 查询大图列表
  getFaceList: 'GET_FACE_LIST' // 查询人脸列表
}

// user相关操作
export const user = {
  getCurrentUser: 'GET_CURRENT_USER' // 获得当前用户
}

// base基础操作
export const base = {
  setView: 'SET_VIEW', // 设置屏幕可视区域信息
  getQiniuToken: 'GET_QINIU_TOKEN' // 获得七牛token
}



// WEBPACK FOOTER //
// ./src/store/mutation-types.js